import { put, takeEvery, call } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import {
  FETCH_INVENTORY_INIT,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAIL,
  DELETE_VEHICLES_INIT,
  DELETE_VEHICLES_SUCCESS,
  DELETE_VEHICLES_FAIL,
  FETCH_COUNTRIES_INIT,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAIL,
  FETCH_SEGMENTS_INIT,
  FETCH_SEGMENTS_SUCCESS,
  FETCH_SEGMENTS_FAIL,
  FETCH_CATEGORIES_INIT,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAIL,
  FETCH_CAPACITY_INIT,
  FETCH_CAPACITY_SUCCESS,
  FETCH_CAPACITY_FAIL,
  FETCH_SUBCAT_INIT,
  FETCH_SUBCAT_SUCCESS,
  FETCH_SUBCAT_FAIL,
  FETCH_BRANDS_INIT,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAIL,
  FETCH_REGION_INIT,
  FETCH_REGION_SUCCESS,
  FETCH_REGION_FAIL,
  FETCH_INSURANCE_INIT,
  FETCH_INSURANCE_SUCCESS,
  FETCH_INSURANCE_FAIL,
  ADD_VEHICLE_INIT,
  ADD_VEHICLE_SUCCESS,
  ADD_VEHICLE_FAIL,
  FETCH_VEHICLE_INIT,
  FETCH_VEHICLE_SUCCESS,
  FETCH_VEHICLE_FAIL,
  FETCH_LOCATION_INIT,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_FAIL,
  EDIT_VEHICLE_INIT,
  EDIT_VEHICLE_SUCCESS,
  EDIT_VEHICLE_FAIL,
  FETCH_USER_DRIVERS_INIT,
  FETCH_USER_DRIVERS_SUCCESS,
  FETCH_USER_DRIVERS_FAIL,
  CREATE_VEHICLE_ACTION,
  CREATE_VEHICLE_FAIL_ACTION,
  CREATE_VEHICLE_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";

function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
    }
  } catch (err) {
    console.error("error", err);
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchvehicleInventory(value) {
  try {
    let page = (value.payload && value.payload.page) || 1;
    let user = JSON.parse(localStorage.getItem("user"));
    let search = (value.payload && value.payload.search) || "";
    let filter = (value.payload && value.payload.filter) || "";
    let subCategoryFilter =
      (value.payload && value.payload.subCategoryFilter) || "";

    let filterParam = "";
    let subCategoryFilterParam = "";
    if (filter) {
      filterParam = `&catgry=${filter}`;
    }
    if (subCategoryFilter) {
      subCategoryFilterParam = `&subCatgry=${subCategoryFilter}`;
    }

    let orgId = user.orgId;
    let params = {
      page: page,
      api: `${appConfig.ip}/vehicleInvntry?orgId=${orgId}&limit=10&page=${page}&ser=${search}${filterParam}${subCategoryFilterParam}`,
      method: "GET",
      sucessAction: FETCH_INVENTORY_SUCCESS,
      failAction: FETCH_INVENTORY_FAIL,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* deleteVehicles(value) {
  let id = value.value.id;
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({
        type: DELETE_VEHICLES_SUCCESS,
        payload: id,
      });
      yield toast.success(`Record deleted`, {
        autoClose: 3000,
        className: "toastClass",
      });
      yield put({
        type: FETCH_INVENTORY_INIT,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_VEHICLES_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCountries() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/country`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_COUNTRIES_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_COUNTRIES_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSegments() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/segment`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SEGMENTS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SEGMENTS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCat(value) {
  const token = localStorage.getItem("token");
  const id = (value.value && value.value.segmentId) || "";
  let byFilter = (value.value && value.value.byFilter) || false;
  let segMentId = "";
  if (id) {
    segMentId = `&sgmntId=${id}`;
  }

  try {
    const res = yield fetch(`${appConfig.ip}/category?${segMentId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      let category = resJSON.rows.map((data) => {
        let categories = {
          value: data.id,
          name: data.name,
        };
        return categories;
      });
      yield put({
        type: FETCH_CATEGORIES_SUCCESS,
        payload: byFilter ? { rows: [] } : resJSON,
        category: category,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CATEGORIES_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCapacity() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/capacity`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CAPACITY_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CAPACITY_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSubCat(value) {
  const token = localStorage.getItem("token");
  const segId = (value.value && value.value.segmentId) || "";
  const catID = (value.value && value.value.catId) || "";
  let byFilter = (value.value && value.value.byFilter) || false;
  let segIdParam = "";
  let catIdParam = "";
  if (segId) {
    segIdParam = `&sgmntId=${segId}`;
  }
  if (catID) {
    catIdParam = `&ctgryId=${catID}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/subCategory?${segIdParam}${catIdParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      let subCategory = resJSON.rows.map((data) => {
        let subCategories = {
          value: data.id,
          name: data.name,
        };
        return subCategories;
      });
      yield put({
        type: FETCH_SUBCAT_SUCCESS,

        payload: byFilter ? { rows: [] } : resJSON,
        subCategory: subCategory,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUBCAT_FAIL, error: err });
    } else {
    }
  }
}

function* fetchBrand() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/brand`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_BRANDS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_BRANDS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchRegion(value) {
  const token = localStorage.getItem("token");
  const cntryId = value.value.cntryId;

  try {
    const res = yield fetch(`${appConfig.ip}/region?countryId=${cntryId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_REGION_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_REGION_FAIL, error: err });
    } else {
    }
  }
}

function* fetchInsurance() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/insurance`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_INSURANCE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_INSURANCE_FAIL, error: err });
    } else {
    }
  }
}

// function* addVehicle(value) {
//   const token = localStorage.getItem("token");
//   let user = JSON.parse(localStorage.getItem("user"));

//   const homeLoc = {
//     addr1: value.value.addr,
//     addr2: value.value.lndmrk,
//     cntry: value.value.cntry,
//     region: value.value.rgn,
//     city: value.value.city,
//     location: value.value.lctn,
//     zip: value.value.zip,
//   };

//   const insurance = {
//     insNo: value.value.insNo,
//     validFrom: new Date(value.value.vldFrmdate).toISOString(),
//     validTill: new Date(value.value.vldTilldate).toISOString(),
//     insType: value.value.insType ? value.value.insType : null,
//     vStatus: value.value.verfctnStatus,
//   };

//   const registration = {
//     regNo: value.value.regNo,
//     regExp: new Date(value.value.expdate).toISOString(),
//     cntryOfReg: value.value.regCntry,
//     stateReg: value.value.regRegion,
//   };

//   const vehcleDetails = {
//     userId: user.id,
//     sgmnt: value.value.segmnt,
//     catgry: value.value.catgry,
//     subCatgry: value.value.subctgry,
//     brand: value.value.brand,
//     cpcty: value.value.cpcty,
//     geoLoc: value.value.geo,
//     model: value.value.mdl,
//     driverId: value.value.driverId,
//     homeLoc: homeLoc,
//     insurance: insurance,
//     regDetail: registration,
//   };

//   try {
//     const res = yield fetch(`${appConfig.ip}/vehicleInvntry`, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(vehcleDetails),
//     });

//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: ADD_VEHICLE_SUCCESS,
//         payload: resJSON,
//       });
//       yield put({ type: FETCH_INVENTORY_INIT });
//       yield put(push("/myvehicles"));
//       yield toast.success("Vehicle added to the inventory", {
//         autoClose: 3000,
//       });
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: ADD_VEHICLE_FAIL, error: err });
//       yield toast.info("Unknown error", {
//         autoClose: 3000,
//       });
//     } else {
//     }
//   }
// }

function* addVehicle(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  const homeLoc = {
    addr1: value.value.addr ? value.value.addr : null,
    addr2: value.value.lndmrk ? value.value.lndmrk : null,
    cntry: value.value.cntry ? value.value.cntry : null,
    region: value.value.rgn ? value.value.rgn : null,
    city: value.value.city ? value.value.city : null,
    location: value.value.lctn ? value.value.lctn : null,
    zip: value.value.zip ? value.value.zip : null,
  };

  const insurance = {
    insNo: value.value.insNo ? value.value.insNo : null,
    validFrom: new Date(value.value.vldFrmdate).toISOString(),
    validTill: new Date(value.value.vldTilldate).toISOString(),
    insType: value.value.insType ? value.value.insType : null,
    vStatus: value.value.verfctnStatus ? value.value.verfctnStatus : null,
  };

  const registration = {
    regNo: value.value.regNo ? value.value.regNo : null,
    regExp: new Date(value.value.expdate).toISOString(),
    cntryOfReg: value.value.regCntry ? value.value.regCntry : null,
    stateReg: value.value.regRegion ? value.value.regRegion : null,
  };

  const vehcleDetails = {
    userId: user.id,
    orgId: user.orgId,
    sgmnt: value.value.segmnt ? value.value.segmnt : null,
    catgry: value.value.catgry ? value.value.catgry : null,
    subCatgry: value.value.subctgry ? value.value.subctgry : null,
    brand: value.value.brand ? value.value.brand : null,
    //cpcty: value.value.cpcty ? value.value.cpcty : null,
    cpcty: value.value.capacity ? value.value.capacity : null,
    geoLoc: value.value.geo ? value.value.geo : null,
    model: value.value.mdl ? value.value.mdl : null,
    driverId: value.value.driver ? value.value.driver : null,
    homeLoc: homeLoc,
    insurance: insurance,
    regDetail: registration,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(vehcleDetails),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();
      console.log("=================resJSON", resJSON);
      let vehicleId = resJSON.id;
      let id = resJSON.driverId ? resJSON.driverId : null;
      console.log("=================resJSON.driverId", resJSON.driverId);

      if (resJSON.driverId !== undefined) {
        yield put({
          type: CREATE_VEHICLE_ACTION,
        });
        try {
          let data = {
            vehicleId: vehicleId,
          };

          const res = yield fetch(`${appConfig.ip}/dProf/` + resJSON.driverId, {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
          });
          if (!res.ok) {
            let errJSON = {};
            try {
              errJSON = yield res.json();
            } catch {}
            throw Object.assign(res, errJSON);
          } else {
            let resJSON = yield res.json();

            yield put({
              type: CREATE_VEHICLE_SUCCESS_ACTION,
              payload: resJSON,
            });
          }
        } catch (err) {
          yield put({
            type: CREATE_VEHICLE_FAIL_ACTION,
            error: err,
          });
        }
      }

      yield put({
        type: ADD_VEHICLE_SUCCESS,
        payload: resJSON,
      });
      yield put({ type: FETCH_INVENTORY_INIT });
      yield put(push("/myvehicles"));
      yield toast.success("Vehicle details added to the inventory", {
        autoClose: 3000,
        className: "toastClass",
      });
    }
  } catch (err) {
    yield put({
      type: ADD_VEHICLE_FAIL,
      error: err,
    });
  }
}

function* fetchSpecificVehicle(value) {
  const token = localStorage.getItem("token");
  let id = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_VEHICLE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_VEHICLE_FAIL, error: err });
    } else {
    }
  }
}

function* fetchLoctn(value) {
  const token = localStorage.getItem("token");
  let countryId = value.value.countryId;
  let regionId = value.value.regionId;

  try {
    const res = yield fetch(
      `${appConfig.ip}/operatingLoc?countryId=${countryId}&regionId=${regionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_LOCATION_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_LOCATION_FAIL, error: err });
    } else {
    }
  }
}

function* editVehicle(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
 console.log("!!!!!!!!!value!value",value)
  let id = value.value.id;

  const homeLoc = {
    addr1: value.value.addr ? value.value.addr : null,
    addr2: value.value.lndmrk ? value.value.lndmrk : null,
    lndmrk:value.value.lndmrk ? value.value.lndmrk : null,
    cntry: value.value.cntry ? value.value.cntry : null,
    region: value.value.rgn ? value.value.rgn : null,
    city: value.value.city ? value.value.city : null,
    location: value.value.lctn ? value.value.lctn : null,
    zip: value.value.zip ? value.value.zip : null,
  };
  console.log("!!!!!!!!!homeLoc!homeLoc",homeLoc)
  const insurance = {
    insNo: value.value.insNo ? value.value.insNo : null,
    validFrom: new Date(value.value.vldFrmdate).toISOString(),
    validTill: new Date(value.value.vldTilldate).toISOString(),
    insType: value.value.insType ? value.value.insType : null,
    vStatus: value.value.verfctnStatus ? value.value.verfctnStatus : null,
  };

  const registration = {
    regNo: value.value.regNo ? value.value.regNo : null,
    regExp: new Date(value.value.expdate).toISOString(),
    cntryOfReg: value.value.regCntry ? value.value.regCntry : null,
    stateReg: value.value.regRegion ? value.value.regRegion : null,
  };

  const vehcleDetails = {
    userId: user.id,
    orgId: user.orgId,
    sgmnt: value.value.segmnt ? value.value.segmnt : null,
    catgry: value.value.catgry ? value.value.catgry : null,
    subCatgry: value.value.subctgry ? value.value.subctgry : null,
    brand: value.value.brand ? value.value.brand : null,
    //cpcty: value.value.cpcty ? value.value.cpcty : null,
    cpcty: value.value.capacity ? value.value.capacity : null,
    geoLoc: value.value.geo ? value.value.geo : null,
    model: value.value.mdl ? value.value.mdl : null,
    driverId: value.value.driver ? value.value.driver : null,
    homeLoc: homeLoc,
    insurance: insurance,
    regDetail: registration,
  };
  console.log("!!!!!!!!!vehcleDetails!vehcleDetails",vehcleDetails)
  try {
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(vehcleDetails),
    });

    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();

      let vehicleId = resJSON.id;
      let id = resJSON.driverId;
      if (resJSON.driverId !== undefined) {
        yield put({
          type: CREATE_VEHICLE_ACTION,
        });
        try {
          let data = {
            vehicleId: vehicleId,
          };
          const res = yield fetch(`${appConfig.ip}/dProf/` + id, {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify(data),
          });
          if (!res.ok) {
            let errJSON = {};
            try {
              errJSON = yield res.json();
            } catch {}
            throw Object.assign(res, errJSON);
          } else {
            let resJSON = yield res.json();

            yield put({
              type: CREATE_VEHICLE_SUCCESS_ACTION,
              payload: resJSON,
            });
            yield put({ type: FETCH_INVENTORY_INIT });
            yield put(push("/myvehicles"));
            yield toast.success("Vehicle details updated", {
              autoClose: 3000,
              className: "toastClass",
            });
          }
        } catch (err) {
          yield put({
            type: CREATE_VEHICLE_FAIL_ACTION,
            error: err,
          });
        }
      }
      yield put({
        type: EDIT_VEHICLE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: EDIT_VEHICLE_FAIL,
      error: err,
    });
  }
}

function* fetchDrivers(params) {
  const token = localStorage.getItem("token");
  let page = (params.params && params.params.page) || 1;
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;

  try {
    const res = yield fetch(
      `${appConfig.ip}/dProf/driverWithoutVehicle?limit=10&page=${page}&orgId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_USER_DRIVERS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_USER_DRIVERS_FAIL, error: err });
    } else {
    }
  }
}

export function* VehicleActionWatcher() {
  yield takeEvery(FETCH_INVENTORY_INIT, fetchvehicleInventory);
  yield takeEvery(DELETE_VEHICLES_INIT, deleteVehicles);
  yield takeEvery(FETCH_COUNTRIES_INIT, fetchCountries);
  yield takeEvery(FETCH_SEGMENTS_INIT, fetchSegments);
  yield takeEvery(FETCH_CATEGORIES_INIT, fetchCat);
  yield takeEvery(FETCH_CAPACITY_INIT, fetchCapacity);
  yield takeEvery(FETCH_SUBCAT_INIT, fetchSubCat);
  yield takeEvery(FETCH_BRANDS_INIT, fetchBrand);
  yield takeEvery(FETCH_REGION_INIT, fetchRegion);
  yield takeEvery(FETCH_INSURANCE_INIT, fetchInsurance);
  yield takeEvery(ADD_VEHICLE_INIT, addVehicle);
  yield takeEvery(EDIT_VEHICLE_INIT, editVehicle);
  yield takeEvery(FETCH_VEHICLE_INIT, fetchSpecificVehicle);
  yield takeEvery(FETCH_LOCATION_INIT, fetchLoctn);
  yield takeEvery(FETCH_USER_DRIVERS_INIT, fetchDrivers);
}
